var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.355469 0.914062)",
          fill: "#566FCE",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9033",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.355469",
              y: "0.914062",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9033)" } }, [
        _c("path", {
          attrs: {
            d: "M46.3555 46.9145L46.3555 0.914062L0.355003 0.914062L0.355003 46.9145L46.3555 46.9145Z",
            fill: "#415CC6",
          },
        }),
        _c("path", {
          attrs: {
            d: "M3.26649 17.0682L16.3645 4.03373C20.2251 0.191882 26.4842 0.191882 30.3447 4.03373L43.4426 17.0682C47.3032 20.9101 47.3032 27.1389 43.4426 30.9808L30.3447 44.0153C26.4842 47.8572 20.2251 47.8572 16.3645 44.0153L3.26649 30.9808C-0.594038 27.1389 -0.594038 20.9101 3.26649 17.0682Z",
            fill: "#5171EE",
          },
        }),
        _c("path", {
          attrs: {
            d: "M18.3559 19.0489C21.1167 16.3014 25.593 16.3014 28.3539 19.0489H28.354C31.1148 21.7965 31.1148 26.2511 28.3539 28.9986C25.593 31.7461 21.1168 31.7461 18.3559 28.9986C15.5949 26.2511 15.5949 21.7965 18.3559 19.0489Z",
            fill: "#7194FF",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }